module.exports = __webpack_public_path__ + "static/international-conference-b50141363148c68a8a44997230ad03ae.jpg";